import { createFileRoute } from '@tanstack/react-router';
import { UAParser } from 'ua-parser-js';

import bgImage from '~/images/background.webp';
import logoImage from '~/images/logo.png';
import { useTranslation } from '~/internationalization/useTranslation';
import { Button } from '~/src/button';
import { APP_NAME } from '~/src/constants';

const APP_STORE_URL = import.meta.env.VITE_APP_STORE_URL;
const PLAY_STORE_URL = import.meta.env.VITE_PLAY_STORE_URL;
const DESKTOP_URL = import.meta.env.VITE_DESKTOP_URL;

function getMobileOs() {
  const os = new UAParser().getOS().name;
  if (os === 'iOS') {
    return 'ios';
  }
  if (os === 'Android') {
    return 'android';
  }
  return 'desktop';
}

export const Route = createFileRoute('/authorization-request')({
  component: AuthorizationRequest,
});

function AuthorizationRequest() {
  const { t } = useTranslation();

  const os = getMobileOs();

  if (os === 'desktop') {
    const qrUri = encodeURIComponent(window.location.href);
    window.location.replace(`${DESKTOP_URL}?qr_uri=${qrUri}`);
    return null;
  }

  const isIos = os === 'ios';
  const storeUrl = isIos ? APP_STORE_URL : PLAY_STORE_URL;

  const handleOpen = () => {
    // The app opens automatically via universal/app links when this page loads.
    // This button is only reached when the app is not installed, so go straight
    // to the store.
    window.location.href = storeUrl;
  };

  return (
    <div
      className="font-inter relative flex h-dvh flex-col items-center bg-black pt-8"
      style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <img src={logoImage} alt={APP_NAME} className="h-16" />

      <div className="absolute inset-0 flex flex-col items-center justify-center gap-6">
        <p className="text-sm tracking-[0.32px] text-white/60">{t('msg_app_tap_to_open')}</p>
        <Button label={t('msg_app_open')} onClick={handleOpen} />
      </div>

      <footer className="mt-auto w-full px-8 lg:px-41">
        <div className="border-t border-white/10 pt-8 pb-5 text-center text-xs text-white/70">
          {t('msg_footer_rights_reserved', { year: new Date().getFullYear() })}
        </div>
      </footer>
    </div>
  );
}
